// extracted by mini-css-extract-plugin
export default {"card":"PieChartCard_card__ePTPQ"};